import { render } from "./userdetailtransaction.vue?vue&type=template&id=47b1d9a5&scoped=true"
import script from "./userdetailtransaction.vue?vue&type=script&lang=js"
export * from "./userdetailtransaction.vue?vue&type=script&lang=js"

import "./userdetailtransaction.vue?vue&type=style&index=0&id=47b1d9a5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tap-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b1d9a5"]])

export default __exports__